import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  takeSnapshot(event : PointerEvent & { params: { url: string } }) {
    const target = event.target as HTMLInputElement | null;
    const authenticityToken = (document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement).content;

    if (target) {
      event.stopPropagation();

      const defaultPrompt = "e.g. 'It's pretty busy and has a good mix of deliveries'";
      let commentary = prompt("Enter any commentary about this dash snapshot", defaultPrompt);

      if (commentary === null) {
        return; // actually the _cancel_ case
      } else if (commentary === defaultPrompt) {
        commentary = null;
      }

      target.disabled = true;

      void fetch(event.params.url, {
        method: "POST",
        credentials: "include",
        body: JSON.stringify({
          commentary: commentary
        }),
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": authenticityToken,
        },
      }).then(() => {
        target.disabled = false;
      });
    }
  }
}
